/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconTooth/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconTooth({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconTooth",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 32,
  height = 32,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "none",
  stroke = "#000"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconTooth.Svg"
  data-view-path={viewPath}
 viewBox="0 0 32 32"
 style={{'--as-1-n86VL': alignSelf,'--mt-2-n86VL': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-n86VL': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-n86VL': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-n86VL': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-n86VL': opacity,'--w-10-n86VL': typeof width === 'number' ? `${width}px` : width,'--h-11-n86VL': typeof height === 'number' ? `${height}px` : height,'--a-7-n86VL': isAnimated ? animation : "none",'--sd-8-n86VL': isAnimated ? strokeDashoffset : 0,'--sd-9-n86VL': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconTooth.SvgPath"
  data-view-path={viewPath}
 d="M26 7.3c0-7-8-3.4-10-3.4S6 .4 6 7.3c0 2.7.7 5.1 1.8 7.2.9 1.7 1.2 3.7.8 5.5-.4 1.9-1.7 9 .4 9 3 0 3-9 7-9s5 9 7 9c2.2 0 .8-7.1.4-9-.4-1.9-.1-3.8.8-5.5 1.1-2 1.8-4.5 1.8-7.2z"
 strokeWidth={2}
 strokeLinecap="round"
 strokeLinejoin="round"
 strokeMiterlimit={10}
 style={{'--f-12-n86VL': fill,'--s-13-n86VL': stroke}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}